import { render, staticRenderFns } from "./CardMessage.vue?vue&type=template&id=a85ac20c&scoped=true&"
import script from "./CardMessage.vue?vue&type=script&lang=js&"
export * from "./CardMessage.vue?vue&type=script&lang=js&"
import style0 from "./CardMessage.vue?vue&type=style&index=0&id=a85ac20c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a85ac20c",
  null
  
)

export default component.exports